<template>
  <a-drawer
    :maskClosable="false"
    width="80%"
    title="详情"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="onClose"
  >
    <div v-if="form && form.id">
      <a-descriptions :column="4" title="基本信息" class="full-width-descriptions">
        <a-descriptions-item label="问题标题"> {{ form.title }} </a-descriptions-item>
        <a-descriptions-item label="问题简述"> {{ form.sketch }}</a-descriptions-item>
        <a-descriptions-item label="备注">
          {{ form.remark }}
        </a-descriptions-item>
        <a-descriptions-item label="排序">
          {{ form.orderSort }}
        </a-descriptions-item>
        <a-descriptions-item label="状态">
          {{ form.status ? '启用' : '禁用' }}
        </a-descriptions-item>
        <a-descriptions-item label="问题内容">
          <a-popover title="查看">
            <template slot="content">
              <div v-html="form.contentInfo"></div>
            </template>
            <a-button type="primary">查看 </a-button>
          </a-popover>
        </a-descriptions-item>
        <a-descriptions-item label="创建时间">
          {{ form.createTime }}
        </a-descriptions-item>
      </a-descriptions>
    </div>
  </a-drawer>
</template>
<script>
import { getProblem } from '@/api/problem/problem'
import { tableMixin } from '@/store/table-mixin'
export default {
  mixins: [tableMixin],
  name: 'Post',
  data() {
    return {
      visible: false,
      form: {},
      errorImage: require('/src/assets/images/defaultImg.png'),
      active: 1,
      placeholderImage: '~@/assets/images/defaultImg.png',
      default: 'this.src="' + require('@/assets/images/defaultImg.png') + '"',
    }
  },
  filters: {},
  created() {
    console.log(this.router, '111111222')
    this.type = 1
  },
  computed: {
    hasPermission() {
      return (permission) => {
        if (this.$store.state.user.userTentant.type === 0) {
          return true
        } else {
          return this.$store.state.user.permissions.includes(permission)
        }
        // return true
      }
    },
  },
  watch: {},
  methods: {
    handleLook(e) {
      window.open(e)
    },
    init(e) {
      getProblem({ id: e.id }).then((res) => {
        // if(res.data.fileImg){
        //     res.data.fileImg=JSON.parse(res.data.fileImg)
        // }
        this.form = res.data
        // this.form.panoramaImg = null
      })
      this.visible = true
    },
    convertMinutes(minutes) {
      const hours = Math.floor(minutes / 60) // 计算小时
      const remainingMinutes = minutes % 60 // 计算剩余的分钟
      return `${hours > 10 ? hours : '0' + hours}:${remainingMinutes > 10 ? remainingMinutes : '0' + remainingMinutes}`
    },
    onImageError(event) {
      // 将事件的目标（即<img>元素）的src设置为本地占位图
      event.target.src = this.placeholderImage
      // 如果你想进一步处理错误，比如发送错误报告，可以在这里添加代码
      // ...
    },
    onClose() {
      const that = this
      that.visible = false
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 切换tabs
    callback(e) {
      console.log(e, '顶顶顶顶')
      this.active = e
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      console.log(postIds, 'postIdspostIds')
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: '是否确认冻结此用户?',
        onOk() {
          return frozenTenant(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('冻结成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
  <style lang="less"  scoped>
img {
  width: 80px;
  height: 80px;
}
.full-width-descriptions {
  width: 100% !important;
  // background: red;
  box-sizing: border-box; /* 确保包含内边距和边框 */
}
.ant-descriptions-item {
  width: 25%;
  // background: red;
}
.ant-descriptions-item-label {
  width: 100px;
  // background: red;
  text-align: left;
}
</style>
    